module.exports = __webpack_public_path__ + "static/media/mapForest.341dc7ac.png";